import React, { Component } from "react";
import { Button, Form, Image } from "react-bootstrap";
import FileComponent from "../ImageUploadComponent";
import { ERROR_MSG, DOCUMENT_FORMATS, STATUS } from "../../constant";
import IconPin from "../../assets/icon-pin.png";
import Forma from "../../assets/Forma 1.svg";
import { Field } from "../../component";
import { get } from "lodash";
import { LoaderPage } from "../../component/Loader";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { modifyDataForPost } from "./helper";
import { getIssueList } from "../../actions/common.action";
import { handleLanguage, handlePaste } from "../../helper";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import {
  UploadAttachmentsWithTitleComponent
  // DisplayAttachments
} from "../reusableComponent";
import { DisplayAttachments } from "../reusableComponent/displayAttachments/indexForward";
import { successToastStyle, errorToastStyle } from "../../customToast";
import { emptyString } from "react-select/lib/utils";
import { ConfirmationComponent } from "../ConfirmationComponent";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";
class ReassignForClarification extends Component {
  state = {
    template: [],
    files: [],
    error: {},
    languageError: null,
    pasteError: false,
    pastedText: "",
    comment: "",
    showCommentPopUp: false
  };

  onChange = (value, key) => {
    const { options } = this.props;
    const data = { [key]: value };

    if (key === "to" && value !== "") {
      this.setState(prev => ({
        error: {
          ...prev.error,
          to: { error: false, message: false }
        }
      }));
    }
    if (key === "to") {
      const find = options.find(key => key.userId === +value);
      data["groupId"] = find && find.groupId;
      data["groupName"] = find && find.groupName;
      data["userId"] = find && find.userId;
    }
    this.setState({ ...data }, () => {
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
  };

  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  toggleMeetingPopUp = () => {
    this.setState({ showCommentPopUp: false }, () => {
      //console.log(this.state.showCommentPopUp);
    });
  };
  returnUploadedImageList = template => {
    this.setState({
      template: template
    });
  };

  onSend = () => {
    const { to, error, comment } = this.state;
    if (
      !error.to ||
      to == "" ||
      get(error, "to.error") ||
      ((comment === undefined || !comment.trim()) &&
        (!error.comment || get(error, "comment.error")))
    ) {
      this.setState({
        languageError: false,
        pasteError: false,
        error: {
          to: {
            error: !to,
            message: !to && ERROR_MSG.DEFAULT_MSG
          },
          comment: {
            error: comment === undefined || !comment.trim(),
            message:
              (comment === undefined || !comment.trim()) &&
              ERROR_MSG.DEFAULT_MSG
          }
        }
      });
    } else {
      this.setState(prevState => ({
        sendTo: !prevState.sendTo,
        showCommentPopUp: true
      }));
    }
  };

  onDelete = e => {
    this.props.onCloseButton("1");
    const { resetAction } = this.props;
    resetAction(e);
  };

  onGetFilesData = files => {
    this.setState({
      files
    });
  };
  onBlur = value => {};
  onSubmit = async e => {
    this.setState({ showCommentPopUp: false });
    const { files, groupId, comment, userId } = this.state;
    const {
      actionDispatch,
      issueDetails: { id },
      callApiOnSuccess,
      isIssueList
    } = this.props;
    const data = modifyDataForPost({ files, id, comment });
    const resp = await actionDispatch(undefined, {
      groupId: +groupId,
      issueCommentCO: data,
      userId: +userId
    });
    if (resp) {
      if (!isIssueList) {
        setTimeout(() => {
          window.location.reload(true);
        }, 1500);
      }
      const { status, message } = resp;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      status && callApiOnSuccess(e);
    }
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      console.error(error.message);
    }
  };

  // uploded comes tru in case of file
  // is uploaded
  onToggleAttachment = index => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  inputLanguage = event => {
    const { issueDetails } = this.props;
    const project = get(issueDetails, "project");
    if (window.event.inputType !== "insertFromPaste") {
      if (
        !event.target.value.match(/[\u0900-\u097F]/) ||
        get(project, "sponsoredByCategory") != "STATE"
      ) {
        let hasInputValue = handleLanguage(event);
        this.setState({
          languageError: hasInputValue,
          pasteError: false,
          comment: event.target.value
        });
      }
    }
  };

  pasteLanguage = () => {
    const { issueDetails } = this.props;
    const project = get(issueDetails, "project");
    if (
      !this.state.comment.match(/[\u0900-\u097F]/) ||
      get(project, "sponsoredByCategory") != "STATE"
    ) {
      let { filterString, hasBadValue } = handlePaste(this.state.comment);
      if (hasBadValue === true) {
        this.setState({
          pasteError: hasBadValue,
          comment: filterString
        });
      }
    }
  };

  render() {
    const {
      template,
      sendTo,
      error,
      reset,
      groupName,
      files,
      toggleAttachementDisplay,
      languageError,
      pasteError,
      comment,
      showCommentPopUp
    } = this.state;
    const {
      isImageUpLoading,
      options,
      headerText = "Reassign For Clarification"
    } = this.props;

    return (
      <div className="forward-to-team">
        {toggleAttachementDisplay ? (
          <UploadAttachmentsWithTitleComponent
            displayModal={toggleAttachementDisplay}
            onCloseModal={this.onToggleAttachment}
            fileFormats={DOCUMENT_FORMATS}
            onSubmit={this.onSuccessUploadOfAttachmets}
          />
        ) : null}
        {/* <h3 className="heading">{headerText}</h3> */}
        <div
          // style={{
          //   background: "#F5F5F5",
          //   border: "1px solid #ced7f4",
          //   height: "35px"
          // }}
          className="forward-to-team-main-div"
          style={{
            marginTop: window.location.pathname == "/issue-detail" ? "12px" : ""
          }}
        >
          <h3 className="heading">{headerText}</h3>
          <div
            //className="btn-icon remove-issue-fwd"
            className="delete-padding"
            title="Delete"
            onClick={this.onDelete}
            //className="delete-icon"
            // style={{
            //   position: "relative",
            //   left: "96%",
            //   bottom: "34px",
            //   width: "17px",
            //   top: "-33px"
            // }}
          >
            <Image src={Forma} alt="Delet Icon" />
          </div>
        </div>
        <Form
          className={`forward-to-team-form ${
            languageError === true || (pasteError === true && comment !== "")
              ? "language-error-border-alert"
              : (get(error, "to.error") || get(error, "comment.error")) &&
                "error-field"
          }`}
        >
          <div className="forward-to-team-form-content">
            <Form.Group className="field-select field-to">
              <Form.Label>
                To <span className="required">*</span>
              </Form.Label>
              {/* <CustomDropdown
                options={[
                  {
                    value: "",
                    label: "- Select -"
                  },
                  ...(options || []).map(function(value) {
                    return {
                      value: value && value.userId ? value.userId : "",
                      label:
                        (value && value.groupName ? value.groupName : "") +
                        (value && value.userName
                          ? " (" + value.userName + ")"
                          : "")
                    };
                  })
                ]}
                onChange={this.onChange}
                width={"-webkit-fill-available"}
                height={"43px"}
                className={
                  get(error, "to.error")
                    ? "issue-action-error"
                    : "issue-action reason-for-clarfication"
                }
                page={"reassign-for-clarification"}
                menuClassName={"issueActionMenu"}
              /> */}
              <Field
                as="select"
                keyName="to"
                onChange={this.onChange}
                onError={this.onError}
                isInvalid={get(error, "to.error")}
                onBlur={this.onBlur}
              >
                <option value="">- Select -</option>
                {(options || []).map(value => {
                  return (
                    <option value={value && value.userId}>
                      {value && value.groupName}{" "}
                      {value.userName ? `(${value.userName})` : ""}
                    </option>
                  );
                })}
              </Field>
            </Form.Group>
            <Form.Group
              className={files.length !== 0 ? "text-area" : "text-area1"}
            >
              {/* <Field
                as="textarea"
                rows="4"
                keyName="comment"
                value={comment}
                onChange={this.onChange}
                onInput={this.inputLanguage}
                onError={this.onError}
                placeholder="Add Description"
                isInvalid={get(error, "comment.error")}
              />
              {console.log("this.state.comment", this.state.comment)}
              {this.state.comment !== null &&
                this.state.comment !== undefined &&
                this.state.comment.length === 0 && (
                  <span
                    className="required"
                    style={{
                      position: "absolute",
                      left: "18%",
                      paddingTop: "6px"
                    }}
                  >
                    *
                  </span>
                )} */}

              <Field
                as="textarea"
                rows="4"
                keyName="comment"
                onChange={this.onChange}
                onError={this.onError}
                //placeholder="Description"
                isInvalid={get(error, "comment.error")}
                value={comment}
                onInput={this.inputLanguage}
                onBlur={this.onBlur}
              />
              {this.state.comment == "" ? (
                <>
                  <label
                    for="some-id"
                    class="textfield-fwd__label textfield-fwd__label--required"
                  >
                    Add Description
                  </label>
                </>
              ) : (
                <></>
              )}
            </Form.Group>
            {files.length !== 0 ? (
              <hr style={{ marginTop: "8px", marginBottom: "0px" }} />
            ) : null}
            <Form.Group className="field-attachment">
              <DisplayAttachments
                filesArr={files}
                //filesArr={meetingOm}
                onRemoveFile={this.onRemoveFile}
                addAttchementRequired={false}
                classes="attachments"
              />
            </Form.Group>
          </div>
          <div className="forward-to-team-footer">
            <div className="forward-to-team-buttons">
              <div className="add-attachment" onClick={this.onToggleAttachment}>
                <div className="add-attachment-button">
                  <Image src={IconPin} alt="Attachment Icon" />
                  Add Attachment
                </div>
              </div>
              <div
                //style={{ position: "relative", left: "71%", bottom: "-3px" }}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  position: "relative"
                }}
              >
                <Button
                  className="btn-orange no-padding-send"
                  onClick={this.onSend}
                  style={{ marginTop: "10px" }}
                >
                  Send
                </Button>
              </div>

              {/* <div
                className="btn-icon remove-issue"
                title="Delete"
                onClick={this.onDelete}
              /> */}
            </div>
          </div>
        </Form>
        {((get(error, "to.error") || get(error, "comment.error")) && (
          <span className="invalid-feedback">Mandatory fields are missing</span>
        )) ||
          null}
        {languageError === true || pasteError === true ? (
          <div className="warning">
            <Image src={CircleWithExclamation} />
            Only English language is supported.
          </div>
        ) : (
          <></>
        )}
        {(showCommentPopUp && (
          <>
            <ConfirmationComponent
              show={showCommentPopUp}
              isLoading={false}
              modalClass={"confirmation-modal"}
              saveHandler={this.onSubmit}
              closeHandler={this.toggleMeetingPopUp}
              content={
                "Are you sure you want to reassign the issue for clarification?"
              }
            />
          </>
          // <div className="forward-to-team-confirmation">
          //   <div className="confirmation-inner">
          //     Are you sure you want to forward this issue to <br />
          //     {groupName}?
          //     <div className="confirmation-buttons">
          //       <Button className="btn-orange" onClick={this.onSubmit}>
          //         Yes
          //       </Button>
          //       <Button className="btn-orange-invert" onClick={this.onSend}>
          //         No
          //       </Button>
          //     </div>
          //   </div>
          // </div>
        )) ||
          null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isImageUpLoading: state.commonReducer.isImageUpLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getIssueListDispatch: getIssueList
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReassignForClarification);
